import { observer } from 'mobx-react-lite'
import React from 'react'
import { Typography } from 'shared/ui'
import { useSmartCallFlowBuilderContext } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/context'
import { SmartCallActionNode } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/Action/ui/SmartCallActionNode/SmartCallActionNode'
import type { ISmartCallNodeProps } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/SmartCallFlowBuilderUi'
import { BusinessHoursStore } from '../../store/BusinessHoursStore.ts'

export const BusinessHoursNode = observer((props: ISmartCallNodeProps) => {
  const { id } = props
  const { getActionById } = useSmartCallFlowBuilderContext()
  const store = getActionById(id)
  if (!(store instanceof BusinessHoursStore)) return null

  return (
    <SmartCallActionNode
      iconProps={BusinessHoursStore.iconProps}
      title={BusinessHoursStore.title}
      placeholder={'Configure'}
      content={
        <Typography ariaLabel={'info'} variant={'body-md-regular'}>
          Within Operating Hours
        </Typography>
      }
      {...props}
    />
  )
})
